import * as React from 'react';

import { ActiveIncidents } from 'components/statusPage/activeIncidents';
import { Incident } from 'components/statusPage/types';

export const useActiveIncidents = (): {
  isLoading: boolean;
  data: Incident[];
} => {
  const [activeIncidents, setActiveIncidents] = React.useState<Incident[]>([]);

  React.useEffect(() => {
    new ActiveIncidents().load().then((incidents) => {
      setActiveIncidents(incidents || []);
    });
  }, []);

  return { isLoading: !activeIncidents, data: activeIncidents };
};
